var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyerSellerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18 4.5C15.5147 4.5 13.5 6.51472 13.5 9C13.5 11.4853 15.5147 13.5 18 13.5C20.4853 13.5 22.5 11.4853 22.5 9C22.5 6.51472 20.4853 4.5 18 4.5ZM10.5 9C10.5 4.85786 13.8579 1.5 18 1.5C22.1421 1.5 25.5 4.85786 25.5 9C25.5 13.1421 22.1421 16.5 18 16.5C13.8579 16.5 10.5 13.1421 10.5 9Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.2507 22.7845C8.29545 23.8844 7.5004 25.1689 7.5004 26.25C7.5004 28.244 7.58102 29.154 8.4476 29.8597C8.93867 30.2596 9.80249 30.6839 11.3605 30.9993C12.9119 31.3134 15.052 31.5 18.0004 31.5C20.9488 31.5 23.0889 31.3134 24.6403 30.9993C26.1983 30.6839 27.0621 30.2596 27.5532 29.8597C28.4198 29.154 28.5004 28.244 28.5004 26.25C28.5004 25.1689 27.7053 23.8844 25.7501 22.7845C23.842 21.7112 21.105 21 18.0004 21C14.8958 21 12.1588 21.7112 10.2507 22.7845ZM8.77987 20.1698C11.215 18.8001 14.478 18 18.0004 18C21.5228 18 24.7858 18.8001 27.2209 20.1698C29.6089 21.5131 31.5004 23.6036 31.5004 26.25C31.5004 26.3101 31.5005 26.371 31.5006 26.4328C31.5033 28.1535 31.5071 30.5087 29.4476 32.1859C28.4387 33.0076 27.0525 33.5719 25.2355 33.9397C23.4119 34.3088 21.052 34.5 18.0004 34.5C14.9488 34.5 12.5889 34.3088 10.7653 33.9397C8.94831 33.5719 7.56213 33.0076 6.5532 32.1859C4.49373 30.5087 4.49747 28.1535 4.5002 26.4328C4.5003 26.371 4.5004 26.3101 4.5004 26.25C4.5004 23.6036 6.39185 21.5131 8.77987 20.1698Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyerSellerIcon);
export default __webpack_public_path__ + "static/media/buyer-seller-icon.eebb4fe59969d6a3a7ad5c2251a97076.svg";
export { ForwardRef as ReactComponent };